export const types = {
  APPEND_EVENT: 'AI_STATUS_APPEND_EVENT',
  CLEAR_LOG: 'AI_STATUS_CLEAR_LOG',
};

// state.byConversation[convId] = { events: [...], final: 'finished'|'error'|null }
const state = {
  byConversation: {},
};

const timers = {};      // per-conversation auto-clear timers

const clearTimer = convId => {
  if (timers[convId]) {
    clearTimeout(timers[convId]);
    delete timers[convId];
  }
};

const scheduleClear = ({ commit }, convId, ms) => {
  clearTimer(convId);
  timers[convId] = setTimeout(() => {
    commit(types.CLEAR_LOG, convId);
    delete timers[convId];
  }, ms);
};

export const getters = {
  // returns { events: [...], final: ... } or null
  getLog: _state => convId => _state.byConversation[convId] || null,
  // legacy compat: last event
  getStatus: _state => convId => {
    const log = _state.byConversation[convId];
    if (!log || !log.events?.length) return null;
    return log.events[log.events.length - 1];
  },
};

export const actions = {
  receive({ commit }, payload) {
    if (!payload?.conversation_id) return;
    const convId = payload.conversation_id;

    // A new `started` resets the log (new generation cycle).
    if (payload.status === 'started') clearTimer(convId);

    commit(types.APPEND_EVENT, { convId, event: payload });

    if (payload.status === 'finished') {
      // Give the manager time to read the full trace before hiding.
      scheduleClear({ commit }, convId, 3000);
    } else if (payload.status === 'error') {
      scheduleClear({ commit }, convId, 15000);
    }
  },

  clear({ commit }, convId) {
    clearTimer(convId);
    commit(types.CLEAR_LOG, convId);
  },
};

export const mutations = {
  [types.APPEND_EVENT](_state, { convId, event }) {
    const existing = _state.byConversation[convId];
    // New `started` begins a fresh log
    const events = event.status === 'started' || !existing
      ? [event]
      : [...existing.events, event];
    // cap log length
    const trimmed = events.length > 20 ? events.slice(-20) : events;
    const final = ['finished', 'error'].includes(event.status) ? event.status : null;
    _state.byConversation = {
      ..._state.byConversation,
      [convId]: { events: trimmed, final },
    };
  },
  [types.CLEAR_LOG](_state, convId) {
    const next = { ..._state.byConversation };
    delete next[convId];
    _state.byConversation = next;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
